import { Footer, Menu, Preview } from '../components';

export const ProductConfigurator = () => (
  <div>
    <div style={{ display: 'flex' }}>
      <Menu />
      <Preview />
    </div>
    <Footer />
  </div>
);
